import React from 'react';
import {
    Document,
    Packer,
    Paragraph,
    TextRun,
    Table,
    TableCell,
    TableRow,
    Media,
    AlignmentType,
    HeadingLevel,
    WidthType,
    ImageRun
} from "docx";
import { Buffer } from 'buffer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileWord } from '@fortawesome/free-solid-svg-icons';
import { saveAs } from "file-saver";
import { currencyFormat } from '../../js/Functions';
import Dents from "../../images/Dents.png";

class MovementsWord extends React.Component {
    getImageBuffer = async (imageUrl) => {
        const response = await fetch(imageUrl);
        return await response.arrayBuffer();
    }
    exportToWord = async () => {
        const { data } = this.props;
        const imageBuffer = await this.getImageBuffer(Dents);
        if (!Array.isArray(data) || data.length === 0) return;
        // TOTAL
        let total = 0;
        let total_ingresos = 0;
        let total_egresos = 0;
        // Creamos filas de la tabla
        const tableRows  = [
            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "FECHA", bold: true })]
                            })
                        ]
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "DESCRIPCION", bold: true })]
                            })
                        ]
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "TIPO MOVIMIENTO", bold: true })]
                            })
                        ]
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "VALOR", bold: true })]
                            })
                        ]
                    }),
                ]
            }),
            ...data.map((item) => {
                const amount = parseFloat(item.AMOUNT || 0);
                if (Number(item.MOV_TYPE) === 1) {
                    total_ingresos += amount;
                } else {
                    total_egresos += amount;
                }
                return new TableRow({
                    children: [
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: item.DATE || ""
                                        })
                                    ]
                                })
                            ]
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: item.DESCRIPTION || ""
                                        })
                                    ]
                                })
                            ]
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text:
                                                Number(item.MOV_TYPE) === 1
                                                    ? "INGRESO"
                                                    : "EGRESO",
            
                                            color:
                                                Number(item.MOV_TYPE) === 1
                                                    ? "008000"
                                                    : "FF0000",
            
                                            bold: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    alignment: AlignmentType.RIGHT,
                                    children: [
                                        new TextRun({
                                            text: `$ ${currencyFormat(amount)}`,
                                            bold: true
                                        })
                                    ]
                                })
                            ]
                        }),
                    ],
                });
            }),
        ];

        // Documento
        const total_ganancias = total_ingresos - total_egresos;
        const doc = new Document({
            styles: {
                default: {
                    document: {
                        run: {
                            font: "Cabin", // Usar tu fuente preferida
                        },
                    },
                },
            },
            sections: [
                {
                    children: [
                        // LOGO
                        new Paragraph({
                            children: [
                                new ImageRun({
                                    data: imageBuffer,
                                    transformation: {
                                        width: 180,
                                        height: 100,
                                    },
                                }),
                            ],
                            alignment: AlignmentType.LEFT,
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({ text: "", break: 1 }) // Agrega un salto de línea visual
                            ],
                        }),
                        // TÍTULO
                        new Paragraph({
                            text: "INGRESOS Y EGRESOS",
                            heading: HeadingLevel.HEADING_1,
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 200 },
                        }),

                        // TABLA
                        new Table({
                            rows: tableRows,
                            width: {
                                size: 100,
                                type: WidthType.PERCENTAGE,
                            },
                        }),

                        // TOTAL
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `Total Ingresos: $${total_ingresos.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`,
                                    bold: true,
                                    color: "008000"
                                }),
                            ],
                            spacing: { before: 300 },
                        }),
                        
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `Total Egresos: $${total_egresos.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`,
                                    bold: true,
                                    color: "FF0000"
                                }),
                            ],
                            spacing: { before: 120 },
                        }),
                        
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `Total Ganancias: $${total_ganancias.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`,
                                    bold: true,
                                    color: total_ganancias >= 0 ? "008000" : "FF0000"
                                }),
                            ],
                            spacing: { before: 120 },
                        }),
                    ],
                },
            ],
        });

        // Guardar archivo
        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "Movimientos_Ingresos_Egresos.docx");
        });
    }
    render() {
        const { data } = this.props;
        if (!Array.isArray(data) || data.length === 0) return null;
        return (
            <button
                style={{ color: '#FFFFFF' }}
                type="button"
                className="btn btn-info btn-sm"
                onClick={this.exportToWord}
            >
                <FontAwesomeIcon style={{ color: '#FFFFFF' }} icon={faFileWord} />
            </button>
        );
    }
}

export default MovementsWord;